<template>
    <div class="p-0">
        <div class="font-color-171717">
            <div style="width: 100%;background-size: cover; margin: auto;color: #fff">
                <CCard class="bg-white b-20 m-3 p-20 mb-5" style="border:none;">
                    <CRow class="m-2">
                        <CCol sm="12">
                            <h3 class="custom-40px-500 text-center mt-3">Select Your Candidate</h3>
                            <p class="custom-18px-400 text-center m-2">Subscribe to view the details and watch the interview videos of up to 25 candidates</p>
                        </CCol>
                        <CCol sm="12">
                            <CRow>
                                <CCol sm="10">
                                    <CInput type="text" placeholder="Search Candidate" v-model="searchQuery" @keyup.enter="filterList" />
                                </CCol>
                                <CCol sm="2" style="margin:-30px auto">
                                    <label for="itemsPerPage" class="p-0">Items per page:</label>
                                    <select v-model="itemsPerPage" id="itemsPerPage" class="form-control">
                          <option value="10">Show 10</option>
                          <option value="20">Show 20</option>
                          <option value="50">Show 50</option>
                        </select>
                                </CCol>
                            </CRow>
                            
                            <template v-if="Busy == true">
                      <div class="container text-center">
                        <pulse-loader :loading="loading" :color="color" :size="size"></pulse-loader>
                      </div>
</template>
                <CDataTable hover class="table-align-middle mb-0 font-color-171717" :items="filteredList" :fields="fields" :items-per-page="itemsPerPage" :pagination="true">
<template #thead-top>
    <tr>
        <th colspan="5">
            <input type="checkbox" v-model="selectAll" @change="toggleSelectAll"> Select All
        </th>
    </tr>
</template>

<template #CandidateName="{ item }">
    <td>
        <input type="checkbox" v-model="selectedItems" :value="item.sessionId" class="mr-2" />
        <img v-if="item.profilePhoto !== '' && item.profilePhoto !== null" :src="item.profilePhoto" width="30px" height="30px" style="border-radius: 50%; border: 1px solid #fff; object-fit: cover;" />
        <img v-else src="../assets/img/2-2.png" width="30px" height="30px" style="border-radius: 50%; border: 1px solid #fff; object-fit: cover;" />
        <label class="custom-12px-500 ml-2">{{ item.name }}</label>
    </td>
</template>

<template #Email="{ item }">
    <td>
        {{ item.email }}
    </td>
</template>

<template #Interview="{ item }">
    <td>
        {{ item.sessionName }}
    </td>
</template>

<template #Preview="{ item }">
    <td>
        <label class="custom-border-purple p-2 mr-5 text-white" @click="openVideoPopup(item)">Display</label>
    </td>
</template>

<template #Video="{ item }">
    <td>
        <label class="custom-border-purple p-2 mr-5 text-white bg-C2C2C4">Watch</label>
    </td>
</template>
                </CDataTable>
                <div class="text-center">
                  <label class="custom-border-purple p-2 mr-5 text-white" @click="submitSelected">Submit</label>
                </div>
                <!-- <div class="font-color-171717"> Showing {{ startIndex }} to {{ endIndex }} of {{ totalItems }} entries </div> -->
              </CCol>
            </CRow>
            <div v-if="isPopupSuccess" class="popup-all backdrop-all">
            <div class="popup-all1">
                <!-- Popup content -->
                <div class="text-center">
                    <img style="max-width: 300px" src="../assets/img/successPopup.png" />
                    <h3 class="custom-28px-500 font-color-171717 text-center mt-3">
                        Successfully Shortlisted Candidate
                    </h3>
                    <CButton class="custom-border-purple mt-4 text-white" @click="closeSuccess" style="width:100px">
                        <span class="ml-2 mr-2">OK</span>
                    </CButton>
                </div>
            </div>
        </div>

        <div v-if="isPopupError" class="popup-all backdrop-all">
            <div class="popup-all1">
              <div class="text-right">
                  <img src="../assets/img/close.png" style="max-width:50px;" @click="closePopup" />
                </div>
                <!-- Popup content -->
                <div class="text-center">
                    <img style="max-width: 100px" src="../assets/img/error.png" />
                    <h3 class="custom-28px-500 font-color-171717 text-center mt-3">
                      Oops!
                    </h3>
                    <h4 class="custom-16px-400 text-center font-color-687588">You have exceeded the credit. Please reduce the number of selected candidates or you can add credits.</h4>
                    <CButton class="custom-border-purple mt-4 text-white" @click="closePopup" style="width:100px">
                        <span class="ml-2 mr-2">OK</span>
                    </CButton>
                </div>
            </div>
        </div>


            <div v-if="isPopupVisible3" class="popup-all backdrop-all">
              <div class="popup-all1 font-color-171717">
                <div class="text-right">
                  <img src="../assets/img/close.png" style="max-width:50px;" @click="closeVideoPopup" />
                </div>
                <span class="mt-1 custom-light-purple">Question {{ questionVideo.IndexNo }}:</span>
                <p class="mt-3 custom-12px-600 text-black">
                  <strong>{{ questionVideo.Question }}</strong>
                </p>
                <p class="custom-12px-400">{{ questionVideo.Answer }}</p>
              </div>
            </div>
          </CCard>
          <br />
          <br />
          <br />
        </div>
    </div>
    </div>
  </template>

<script>
import Vue from "vue";
import {
    Carousel3d,
    Slide
} from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";
Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";
Vue.use(Carousel3d);
import backgroundUrl from "../assets/img/bg.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundMap from "../assets/img/Map.png";
import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import backgroundUrNoArrow from "../assets/img/bgline.png";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        PulseLoader
    },
    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundMap,
            backgroundUrNoArrow,
            isPopupVisible2: false,
            list: [],
            user: {},
            isPopupVisible3: false,
            videoUrl: '',
            searchQuery: '',
            Busy: false,
            questionVideo: {},
            currentPage: 1,
            itemsPerPage: 10,
            fields: [{
                    key: 'CandidateName'
                }, {
                    key: 'Email'
                },
                {
                    key: 'Interview'
                }, {
                    key: 'Preview'
                }, {
                    key: 'Video'
                },
            ],
            selectedItems: [],
            selectAll: false,
            isPopupSuccess: false,
            isPopupError: false,
        };
    },
    async mounted() {
        try {
            const isAuth = await this.UserAuth();
            if (isAuth) {
                await this.GetInfoUser(); // Fetch the user details first

                this.getListVideo();

            } else {
                this.GoToLogin();
            }
        } catch (error) {
            this.GoToLogin();
            console.error("Error during authentication:", error);
            // Handle the error here
        }
    },
    computed: {
        filteredList() {
            const query = this.searchQuery.toLowerCase().trim();
            // Filter the list based on the search query and session details
            const filtered = this.list.filter(item => {
                const matchesQuery = query ? item.name.toLowerCase().includes(query) : true;
                const hasRelevantSessionDetails = item.SessionDetails && item.SessionDetails.length > 0 && item.SessionDetails.some(detail => detail.indexNo === 1 && detail.url !== "No recorded video.");
                return matchesQuery && hasRelevantSessionDetails;
            });
            // Sort the filtered list by name
            return filtered;
        },
        totalItems() {
            return this.filteredList.length;
        },
        pagedList() {
            // Paginate the filtered list based on currentPage and itemsPerPage
            const startIndex = (this.currentPage - 1) * this.itemsPerPage;
            return this.filteredList.slice(startIndex, startIndex + this.itemsPerPage);
        },
        startIndex() {
            return (this.currentPage - 1) * this.itemsPerPage + 1;
        },
        endIndex() {
            return Math.min(this.currentPage * this.itemsPerPage, this.totalItems);
        }
    },
    methods: {
        toggleSelectAll() {
            if (this.selectAll) {
                // Select all items
                this.selectedItems = this.filteredList.map(item => item.sessionId);
            } else {
                // Deselect all items
                this.selectedItems = [];
            }
        },
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.user = response.data;
                    console.log("userInfo", this.user);
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        async getListVideo() {
            try {
                this.Busy = true;
                const response = await this.$API.get(this.$GetListUserNotListedShortlisted);
                if (response.status === 200) {
                    this.Busy = false;
                    this.list = response.data;
                    this.photoURL = this.list.profilePhoto;
                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },
        closePopup1() {
            this.isPopupVisible2 = false
        },
        OpenConfirmation() {
            this.isPopupVisible2 = true;
        },
        openVideoPopup(item) {
            this.sessionId = item.sessionId;
            this.getListQuestion(1, this.sessionId);
            this.isPopupVisible3 = true;
        },
        async getListQuestion(index, sessionId) {
            try {
                const response = await this.$API.get(`${this.$GetNextQuestionVideo}/${sessionId}/${index}`, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.questionVideo = response.data;
                } else {}
            } catch (error) {}
        },
        // Method to close the video popup
        closeVideoPopup() {
            this.isPopupVisible3 = false;
            // Optionally, you can clear the video URL when the popup is closed
            // this.videoUrl = '';
        },
        closePopup()
        {
          this.isPopupError = false;
        },
        submitSelected() {
            const sessionJson = this.selectedItems.map(sessionId => {
                const selectedItem = this.filteredList.find(item => item.sessionId === sessionId);
                if (selectedItem) {
                    return {
                        SessionId: selectedItem.sessionId,
                        CandidateUserId: selectedItem.userId,
                        UserId: this.user.id,
                    };
                }
                return null; // Handle case where selectedItem is not found
            }).filter(item => item !== null); // Filter out null entries

            const countCandidate = sessionJson.length;

            if (countCandidate > this.user.credit) {
                alert("Over Limit");
            } else {
                // Filter selected items from filteredList based on selectedItems

                const formData = new FormData();
                formData.append("candidateJson", JSON.stringify(sessionJson));
                formData.append("countCandidate", countCandidate.toString()); // Ensure countCandidate is a string
                formData.append("companyUserId", this.user.id.toString()); // Ensure companyUserId is a string

                this.$API.post(this.$InsertShorlistedCandidate, formData)
                    .then(response => {
                        if (response.status === 200) {
                            this.isPopupSuccess = true;
                            this.getListVideo();
                        } else {
                            this.Loading = false;
                            this.Error = true;
                            this.Message = response.data.message;
                        }
                    })
                    .catch(error => {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = error.response.data.message;
                    });
            }

        },
        closeSuccess() {
            this.isPopupSuccess = false;
        },
        GoToLogin() {
            let path = this.$router.currentRoute.path;
            if (path.toLowerCase() != "/Login") {

                this.$router.push({
                    path: '/Login',
                    query: {
                        targetUrl: this.$router.currentRoute.fullPath,
                    }
                })

            }
        },

    }
};
</script>

<style scoped>
.form-inline label {
    color: #171717;
}

.page-item.active .page-link {
    z-index: 3;
    color: #4f5d73;
    background-color: #F7F7F7;
    border-color: #F7F7F7;
}

.page-link {
    position: relative;
    display: block;
    padding: 0.5rem 0.75rem;
    line-height: 1.25;
    border: 1px solid;
    color: #4f5d73;
    background-color: #fff;
    border-color: #d8dbe0;
}
</style>